const pricing = [
  {
    id: 'express-services',
    label: 'Express Services',
    data: [
      {
        name: 'early-next-day',
        label: 'LSO Early Next Day™',
        price: 'See more details',
        link: '/express-services#es-1',
      },
      {
        name: 'priority-next-day',
        label: 'LSO Priority Next Day™',
        price: 'See more details',
        link: '/express-services#es-2',
      },
      {
        name: 'economy-next-day',
        label: 'LSO Economy Next Day™',
        price: 'See more details',
        link: '/express-services#es-3',
      },
      {
        name: 'second-day',
        label: 'LSO 2nd Day™',
        price: 'See more details',
        link: '/express-services#es-4',
      },
    ],
  },
  {
    id: 'lso-simple',
    label: 'LSO Simple™',
    data: [
      {
        name: 'early-next-day',
        label: 'LSO Simple Early Next Day',
        price: 'See more details',
        link: '/lso-simple#pricing-sec-2',
      },
      {
        name: 'priority-next-day',
        label: 'LSO Simple Priority Next Day',
        price: 'See more details',
        link: '/lso-simple#pricing-sec-3',
      },
      {
        name: 'economy-next-day',
        label: 'LSO Simple Economy Next Day',
        price: 'See more details',
        link: '/lso-simple#pricing-sec-4',
      },
      {
        name: 'second-day',
        label: 'LSO Simple 2nd Day',
        price: 'See more details',
        link: '/lso-simple#pricing-sec-5',
      },
    ],
  },
  {
    id: 'lso-ground-services',
    label: 'LSO Ground Services',
    data: [
      {
        name: 'lso-ground-service1',
        label: 'LSO Ground',
        price: 'See more details',
        link: '/lso-ground-services#pricing-sec-1',
      },
    ],
  },
  {
    id: 'lso-ecommerce-services',
    label: 'LSO E-commerce Services',
    data: [
      {
        name: 'lso-ecommerce-service',
        label: 'LSO E-commerce Service',
        price: 'Contact Us',
        link: '/contact-us',
      },
    ],
  },
  {
    id: 'lso-mexico-services',
    label: 'LSO Mexico Services',
    data: [
      {
        name: 'lso-mexico-service',
        label: 'LSO Mexico Service',
        price: 'See more details',
        link: '/lso-mexico-services#pricing-sec-1',
      },
    ],
  },
]

export default pricing
